var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const hasKeyValues = (values) => "key" in ((values == null ? void 0 : values[0]) ?? []);
const isTextOnlyObject = (obj) => "text_only" in (obj ?? {});
const isTextWithImagesObject = (obj) => "text_with_images" in (obj ?? {});
const hasTextOnlyObject = (values) => isTextOnlyObject(values == null ? void 0 : values[0]);
const hasTextWithImagesObject = (values) => isTextWithImagesObject(values == null ? void 0 : values[0]);
const isComposableWindow = (values) => hasTextOnlyObject(values) || hasTextWithImagesObject(values);
class ModuleSettingsStore {
  constructor(values) {
    __publicField(this, "_rawKV", []);
    __publicField(this, "_rawCW", []);
    __publicField(this, "_rawProperties", []);
    __publicField(this, "_kvObject", {});
    __publicField(this, "_cwObject", {});
    __publicField(this, "_cwMetadataObject", {});
    __publicField(this, "_cwImageObject", {});
    __publicField(this, "_propertiesObject", {});
    __publicField(this, "_defaultValue", "");
    if ((values == null ? void 0 : values.key_value) && hasKeyValues(values.key_value)) {
      this._rawKV = values.key_value;
      this.generateKeyValueObject(values.key_value);
    }
    if ((values == null ? void 0 : values.composable_window) && isComposableWindow(values.composable_window)) {
      this._rawCW = values.composable_window;
      this.generateComposableWindowObject(values.composable_window);
    }
    if (Array.isArray(values == null ? void 0 : values.properties)) {
      this._rawProperties = values.properties;
      for (const prop of this._rawProperties) {
        for (const [key, value] of Object.entries(prop)) {
          this._propertiesObject[key] = value;
        }
      }
    }
  }
  get composable_window() {
    return this._cwObject;
  }
  get composable_window_image() {
    return this._cwImageObject;
  }
  get key_value() {
    return this._kvObject;
  }
  get properties() {
    return this._propertiesObject;
  }
  generateAndMergeAllObjects(values) {
    if ((values == null ? void 0 : values.key_value) && hasKeyValues(values.key_value)) {
      this.generateKeyValueObject(values.key_value);
    }
    if ((values == null ? void 0 : values.composable_window) && isComposableWindow(values.composable_window)) {
      this.generateComposableWindowObject(values.composable_window);
    }
    if (Array.isArray(values == null ? void 0 : values.properties)) {
      for (const prop of values == null ? void 0 : values.properties) {
        for (const [key, value] of Object.entries(prop)) {
          this._propertiesObject[key] = value;
        }
      }
    }
  }
  get raws() {
    return {
      composable_window: this._rawCW,
      key_value: this._rawCW,
      properties: this._rawProperties
    };
  }
  get objects() {
    return {
      cwMetadataObject: this._cwMetadataObject,
      cwObject: this._cwObject,
      kvObject: this._kvObject,
      propertiesObject: this._propertiesObject
    };
  }
  withDefaultValue(defaultValue) {
    this._defaultValue = defaultValue;
    return this;
  }
  getKeyValueItem(keyName) {
    var _a;
    return ((_a = this._kvObject) == null ? void 0 : _a[keyName]) ?? this._defaultValue;
  }
  getComposableWindowItem(keyName) {
    var _a;
    return ((_a = this._cwObject) == null ? void 0 : _a[keyName]) ?? this._defaultValue;
  }
  // NOTE: The following methods ignore _defaultValue in lieu of safe destructuring.
  getPropertiesItem(keyName) {
    var _a;
    return ((_a = this._propertiesObject) == null ? void 0 : _a[keyName]) ?? {};
  }
  getPropertiesItemsKeysItem(keyName) {
    var _a;
    const keysObj = (_a = this._propertiesObject) == null ? void 0 : _a.keys;
    return (keysObj == null ? void 0 : keysObj[keyName]) ?? "";
  }
  getComposableWindowImage(keyName) {
    var _a;
    return ((_a = this._cwImageObject) == null ? void 0 : _a[keyName]) ?? {};
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mergeObjects(destination, source) {
    for (const [key, value] of Object.entries(source)) {
      if (Array.isArray(destination[key])) {
        destination[key].push(value);
      } else {
        destination[key] = value;
      }
    }
  }
  clearObjects() {
    this._kvObject = {};
    this._cwObject = {};
    this._cwMetadataObject = {};
    this._cwImageObject = {};
    this._propertiesObject = {};
  }
  generateKeyValueObject(arr) {
    const obj = {};
    for (const { key, value } of arr) {
      obj[key] = value;
    }
    this.mergeObjects(this._kvObject, obj);
  }
  generateComposableWindowObject(arr) {
    var _a, _b, _c, _d;
    const cwObj = {};
    const imageObj = {};
    const metadataObj = {};
    for (const obj of arr) {
      if (isTextOnlyObject(obj)) {
        const {
          text_only: { body, development_field_key, _metadata }
        } = obj;
        cwObj[development_field_key] = body;
        metadataObj[development_field_key] = _metadata;
      } else if (isTextWithImagesObject(obj)) {
        const {
          text_with_images: {
            body,
            development_key,
            image_inclusion: [image],
            _metadata
          }
        } = obj;
        cwObj[development_key] = body;
        metadataObj[development_key] = _metadata;
        imageObj[development_key] = {
          url: ((_b = (_a = image == null ? void 0 : image.image_picker) == null ? void 0 : _a[0]) == null ? void 0 : _b.url) ?? "",
          ...(_d = (_c = image == null ? void 0 : image.image_picker) == null ? void 0 : _c[0]) == null ? void 0 : _d.dimensions
        };
      }
    }
    this.mergeObjects(this._cwObject, cwObj);
    this.mergeObjects(this._cwMetadataObject, metadataObj);
    this.mergeObjects(this._cwImageObject, imageObj);
  }
}
export {
  ModuleSettingsStore
};
